import { useField } from "formik";
import PhoneInput from "react-phone-input-2";
import i18n from "../../translate/i18n";

type PhoneFieldProps = {
  name: string;
  className?: string;
  country?: string;
};

export default function PhoneField({
  name,
  country = "sy",
}: PhoneFieldProps) {
  const [field, meta, helpers] = useField(name);

  const hasError = Boolean(meta.touched && meta.error);

  return (
    <div>
      <PhoneInput
        country={country}
        onlyCountries={["sy"]}
        disableDropdown
        excludeCountries={["il"]}
        enableSearch
        value={field.value}
        onChange={(phone) => {
          helpers.setValue(
            phone.startsWith("+") ? phone : `+${phone}`
          );
        }}
        onBlur={() => helpers.setTouched(true)}
        inputStyle={{
        borderRadius: "4px",
        width: "100%",
        height: "56px",
        border: hasError? "1px solid red" : "",
        }}
        buttonStyle={{ marginRight: "8px", direction: "ltr" }}
        containerStyle={{
        display: "flex",
        flexDirection: i18n.language === "ar" ? "row-reverse" : undefined,
        }}
        inputProps={{
        autoComplete: "phone",
        }}
      />

      {hasError && (
        <div className="text-red-500 text-sm mt-1">
          {meta.error}
        </div>
      )}
    </div>
  );
}